import { createContext } from 'react'

import type { CombinedListingSearchResult } from '@/queries/CombinedListingSearchResult'

export type CompareSelectionContextValue = {
  compareMode: boolean
  /** Ordered, insertion order preserved, max COMPARE_LIMIT. Keyed on `listingId`. */
  selectedIds: string[]
  /** Full facade objects, cached across page turns and re-read on panel open. */
  selectedListings: CombinedListingSearchResult[]
  /** True when selectedIds.length >= COMPARE_LIMIT. */
  atLimit: boolean
  /** True while ComparePanel is showing. Lives here so the re-read can use it. */
  isPanelOpen: boolean
  toggleCompareMode: () => void
  toggleListing: (id: string) => void
  clearSelection: () => void
  openPanel: () => void
  closePanel: () => void
}

export const CompareSelectionContext =
  createContext<CompareSelectionContextValue | null>(null)
